import React, { useEffect,useState } from "react";
import { Button, Spinner } from "components";
import AffiliateBusinessModal from "components/AffiliateBusinessModal/AffiliateBusinessModal";
import { useSelector } from "react-redux";


import styles from './AffiliateBusinessSelector.module.scss';


const AffiliateBusinessSelector = ({
  affiliateProgramLoading,
  affiliateBusinesses = [],
  affiliateProgramBusinesses = [],
  inputValue,
  productsRequested,
  onInputValueChange,
  onSelectedBusinessIdChange,
  onSelectedBusinessChange,
  onProductsRequestedChange,
  selectedBusiness,
  affiliateType,
  handleFetchProducts,
  OnShowCustomCoupon
}) => {

  const [isModalOpen, setModalOpen] = useState(false)
  const [businessData, setBusinessData] = useState(null)

  useEffect(() => {
    handleInputChange(inputValue)
  }, [affiliateBusinesses])

  const affiliateBusinessesFetching = useSelector(
    (state) => state.affiliateBusiness?.fetching
  );

  const handleCustomCouponCreate = () => {
    onProductsRequestedChange(true)
    OnShowCustomCoupon()
  }

  const handleAddAffiliateBusiness = () => {
    const affiliateBusiness = affiliateProgramBusinesses?.find((b) => b.mid == Number(inputValue));
    const business = {
      name: affiliateBusiness?.name,
      affiliate_code: affiliateBusiness?.mid,
      logo: affiliateBusiness?.logoURL,
      business_web_url: affiliateBusiness?.url,
      is_affiliate: true,
      affiliate_type: affiliateType,
      createAffiliate: true,
    };
    setBusinessData(business);
    setModalOpen(true);
  };


  const handleInputChange = (value) => {
    onInputValueChange(value)
    onProductsRequestedChange(false)
    const selectedBusiness = affiliateBusinesses?.find(b => String(b.affiliate_code) === value);
    onSelectedBusinessIdChange(selectedBusiness?.id || null);
    onSelectedBusinessChange(selectedBusiness)
  }


  const handleEdit = (business) => {
    setBusinessData(business);
    setModalOpen(true);
  };

  return (
    <div className={styles.container}>
      <div className={styles.controls}>
        <Button
          className={styles.button}
          onClick={() => { setBusinessData(null); setModalOpen(true); }}
        >
          Add New Business
        </Button>
      </div>

      {(affiliateProgramLoading.products && !productsRequested) ||
        affiliateProgramLoading?.businesses ||
         affiliateBusinessesFetching ? (
        <Spinner show />
      ) : (
        <>
          <select
            className={styles.select}
            value={inputValue}
            onChange={(e) => handleInputChange(e.target.value)}
          >
            <option value="">Select Marketer</option>
            {affiliateProgramBusinesses.map((affiliateBusiness) => (
              <option key={affiliateBusiness.mid} value={affiliateBusiness.mid}>
                {`${affiliateBusiness.name} (${affiliateBusiness.mid})`}
              </option>
            ))}
          </select>

          <Button
            className={styles.button}
            disabled={!selectedBusiness}
            onClick={() => handleEdit(selectedBusiness)}
          >
            Edit Selected
          </Button>

          <div className={styles.buttonsWrapper}>
            {inputValue && !affiliateBusinesses?.some((b) => String(b.affiliate_code) === inputValue) ? (
              <div className={styles.notFoundMessage}>
                <p>This affiliate business is not in our database</p>
                <Button className={styles.button} onClick={handleAddAffiliateBusiness}>Add Business</Button>
              </div>
            ) : (
              <>
                <Button disabled={!selectedBusiness} className={styles.button} onClick={handleFetchProducts}>
                  Get All Affiliate Product Deals
                </Button>
                <Button
                  className={styles.button}
                  disabled={!selectedBusiness}
                  onClick={() => handleCustomCouponCreate()}
                >
                  Custom Coupon +
                </Button>
              </>
            )}
          </div>
        </>
      )}

      <AffiliateBusinessModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        business={businessData}
      />
    </div>

  );
};

export default AffiliateBusinessSelector;
